module.exports = __webpack_public_path__ + "img/1x.465d92d.jpg";